<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    :width="width"
    :height="height"
  >
    <defs>
      <filter :id="uuid"><feGaussianBlur :stdDeviation="blurPixel" /></filter>
    </defs>
    <image
      :xlink:href="url"
      :width="width"
      :height="height"
      :filter="`url(#${uuid})`"
    />
  </svg>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'

const ua = navigator.userAgent.toLowerCase()
const isIE = ua.indexOf('msie') >= 0 || ua.indexOf('trident') >= 0

export default {
  props: {
    px: {
      default: 0,
      type: Number
    },
    width: {
      default: '0',
      type: String
    },
    height: {
      default: '0',
      type: String
    },
    url: {
      default: '',
      type: String
    }
  },
  data() {
    return {
      uuid: `blur_${uuidv4()}`
    }
  },
  computed: {
    blurPixel() {
      return isIE ? this.px : 0
    }
  }
}
</script>
